/*
* This file contain all reducer's state for all actions that are related to login
*/
import _ from 'lodash';

const initialState = {
  token: null,
  isAuthenticating: false,
  currentUser : null,
  subsuser : null,
  company: null,
  companydetail:null,
  companymembers: null,
  authenticatingEmail: false,
  companyjobs: null,
  alljobs: null,
  subscriptions: null,
  stats: null,
  disableButtonLogin: false,
  gettingloggedinuserdata : false,
  loggedInUser : {}
};

export default function login(state = initialState, action) {
  switch(action.type) {
    case 'AUTHENTICATE_REQUEST':
      return Object.assign({}, state, {
        isAuthenticating: true,
        disableButtonLogin: true
      });

    case 'AUTHENTICATE_SUCCESS':
      if(action.usertype===3){
        window.localStorage.setItem('agl-token', action.token);
        window.localStorage.setItem('userType', action.usertype);
        window.location.href = '/admin-dashboard';
      }else{
        
        window.localStorage.setItem('agl-token', action.token);
        window.localStorage.setItem('userType', action.usertype);
        window.localStorage.setItem('tokenStatus', action.tokenStatus);
        window.location.href = '/job';
      }

      return Object.assign({}, state, {
        isAuthenticating: false,
        token: action.token,
        disableButtonLogin: false,
      });

    case 'AUTHENTICATE_FAILURE':
      return Object.assign({}, state, {
        isAuthenticating: false,
        error: action.error,
        disableButtonLogin: false
      });
    case 'CURRENT_USER_FETCH_REQUEST':
      return state;

    case 'CURRENT_USER_FETCH_SUCCESS':
      // localStorage.setItem('companyData', action.companyData);
      if(action.adminData.type !== 3){
        localStorage.setItem('tokenStatus', action.tokenStatus.tokenStatus);
      }
      return Object.assign({}, state, {
        currentUser : action.user,
        subsuser: action.subsuser,
        company: action.company,
        companydetail: action.companydetail,
        companymembers: action.companymembers,
        subscriptions: action.subscriptions,
        alljobs: action.alljobs,
        companyjobs: action.companyjobs,
        stats: action.stats,
        tokenStatus: action.tokenStatus,
        companyData: action.companyData,
        adminData: action.adminData,
        subscriptionhistory: action.subscription_history,
        SubscriptionActive: action.SubscriptionActive,
        allusers: action.allusers,
        count:action.count,
      });
      
    case 'CURRENT_USER_FETCH_FAILURE':
      /*window.localStorage.removeItem('agl-token');
      window.localStorage.removeItem('agl-username');
      window.localStorage.removeItem('userType');
      window.localStorage.removeItem('temp_company_id');
      window.localStorage.removeItem('temp_user_id');
      window.location.href = '/';*/
      return Object.assign({}, state, {

      });
    case 'AUTHENTICATE_EMAIL_SUCCESS':
      return Object.assign({}, state, {
        authenticatingEmail: true
      });
    case 'FORGET_POPUP_RESET':
      return Object.assign({}, state, {
        authenticatingEmail: false
      });

    case 'GET_LOGGEDIN_USER_REQUEST':
      return Object.assign({}, state, {
        gettingloggedinuserdata: true
      });

    case 'GET_LOGGEDIN_USER_REQUEST_SUCCESS':
      return Object.assign({}, state, {
        gettingloggedinuserdata: false,
        loggedInUser : action.loggeInUser.data
      });

    case 'NEW_SUBS_HISTORY_DATA': return Object.assign({}, state, {
      allJobsCount: action.allJobsCount,
      alljobs : action.alljobs
    });
    case 'SEARCH_COMPANY_SUCCESS': return Object.assign({}, state, {
      company : action.company,
      count : action.count
    });
    case 'SEARCH_JOB_SUCCESS': return Object.assign({}, state, {
      alljobs : action.alljobs,
      allJobsCount : action.allJobsCount
    });
    case 'GET_LOGGEDIN_USER_REQUEST_FAILURE':

       window.localStorage.removeItem('agl-token');
      window.localStorage.removeItem('agl-username');
      window.localStorage.removeItem('userType');
      window.localStorage.removeItem('temp_company_id');
      window.localStorage.removeItem('temp_user_id');

      return Object.assign({}, state, {
        gettingloggedinuserdata: false,
        token: null,
        isAuthenticating: false,
        currentUser : null,
        subsuser : null,
        company: null,
        companydetail:null,
        companymembers: null,
        authenticatingEmail: false,
        companyjobs: null,
        alljobs: null,
        subscriptions: null,
        stats: null,
        disableButtonLogin: false,
        loggedInUser : {}
      });

    case 'CANCEL_DOKKIT_SUCCESS': {
      const {companyId} = action.payload     
      let  companies = [...state.company];
      companies = _.filter(companies, function(o) { return o._id !==  companyId})
      return {
          ...state,
          company : [...companies]
      }
     }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducers/login.js